import { createRouter, createWebHashHistory } from 'vue-router';
import Mainview from '../views/mainview';

const routes = [
    { path: '/', component: Mainview },
    { path: '/mainview', component: Mainview },
    { path: '/memberarea', component: () => import('../views/memberarea/index') },
    { path: '/memberbenefits', component: () => import('../views/memberbenefits/index') },
    { path: '/crosscooperation', component: () => import('../views/crosscooperation/index') },
    { path: '/brandintroduction', component: () => import('../views/brandintroduction/index') },
    { path: '/brandhistory', component: () => import('../views/brandhistory/index') },
    { path: '/storeimage', component: () => import('../views/storeimage/index') },
    { path: '/storelist', component: () => import('../views/storelist/index') },
    { path: '/recruitment', component: () => import('../views/recruitment/index') },
    { path: '/investment', component: () => import('../views/investment/index') },
    { path: '/productlist', component: () => import('../views/productlist/index') },
    { path: '/checkproduct', component: () => import('../views/checkproduct/index') },
    { path: '/goldprice', component: () => import('../views/goldprice/index') },
    { path: '/freeservices', component: () => import('../views/freeservices/index') },
    { path: '/chatour', component: () => import('../views/chatour/index') },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

router.beforeEach((to, from, next) => {
    if (to.path) {
        localStorage.setItem('currentRoute', to.fullPath);
    }
    next();
});


export default router;